/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { IndexManagementResponse } from '../api-models';
/**
 * IndexManagementApi - axios parameter creator
 * @export
 */
export const IndexManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Indexes employees for a specific facility based on employee IDs.
         * @param {string} facilityId The unique identifier of the facility.
         * @param {Array<number>} [requestBody] A list of primary key employee IDs to be indexed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminIndexManagementFacilityEmployeesFacilityIdPost: async (facilityId: string, requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminIndexManagementFacilityEmployeesFacilityIdPost', 'facilityId', facilityId)
            const localVarPath = `/Admin/index-management/facility-employees/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Re-index all employees based on their SaaS Employee IDs
         * @param {Array<string>} [requestBody] An array of SaaS Employee IDs to be indexed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminIndexManagementSaasEmployeesPost: async (requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/index-management/saas-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Re-index all employees belonging to a specific TeamSupport customer
         * @param {string} idOrDatabaseName The ID or database name of the TeamSupport customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminIndexManagementTeamSupportCustomerIdOrDatabaseNamePost: async (idOrDatabaseName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idOrDatabaseName' is not null or undefined
            assertParamExists('adminIndexManagementTeamSupportCustomerIdOrDatabaseNamePost', 'idOrDatabaseName', idOrDatabaseName)
            const localVarPath = `/Admin/index-management/team-support-customer/{idOrDatabaseName}`
                .replace(`{${"idOrDatabaseName"}}`, encodeURIComponent(String(idOrDatabaseName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Re-index all records in a Facility Database
         * @param {string} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllEmployeesInADatabaseFacility: async (databaseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('indexAllEmployeesInADatabaseFacility', 'databaseId', databaseId)
            const localVarPath = `/Admin/index-management/database/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IndexManagementApi - functional programming interface
 * @export
 */
export const IndexManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IndexManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Indexes employees for a specific facility based on employee IDs.
         * @param {string} facilityId The unique identifier of the facility.
         * @param {Array<number>} [requestBody] A list of primary key employee IDs to be indexed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminIndexManagementFacilityEmployeesFacilityIdPost(facilityId: string, requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndexManagementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminIndexManagementFacilityEmployeesFacilityIdPost(facilityId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Re-index all employees based on their SaaS Employee IDs
         * @param {Array<string>} [requestBody] An array of SaaS Employee IDs to be indexed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminIndexManagementSaasEmployeesPost(requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndexManagementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminIndexManagementSaasEmployeesPost(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Re-index all employees belonging to a specific TeamSupport customer
         * @param {string} idOrDatabaseName The ID or database name of the TeamSupport customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminIndexManagementTeamSupportCustomerIdOrDatabaseNamePost(idOrDatabaseName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndexManagementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminIndexManagementTeamSupportCustomerIdOrDatabaseNamePost(idOrDatabaseName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Re-index all records in a Facility Database
         * @param {string} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexAllEmployeesInADatabaseFacility(databaseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndexManagementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexAllEmployeesInADatabaseFacility(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IndexManagementApi - factory interface
 * @export
 */
export const IndexManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IndexManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Indexes employees for a specific facility based on employee IDs.
         * @param {IndexManagementApiAdminIndexManagementFacilityEmployeesFacilityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminIndexManagementFacilityEmployeesFacilityIdPost(requestParameters: IndexManagementApiAdminIndexManagementFacilityEmployeesFacilityIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<IndexManagementResponse> {
            return localVarFp.adminIndexManagementFacilityEmployeesFacilityIdPost(requestParameters.facilityId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Re-index all employees based on their SaaS Employee IDs
         * @param {IndexManagementApiAdminIndexManagementSaasEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminIndexManagementSaasEmployeesPost(requestParameters: IndexManagementApiAdminIndexManagementSaasEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<IndexManagementResponse> {
            return localVarFp.adminIndexManagementSaasEmployeesPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Re-index all employees belonging to a specific TeamSupport customer
         * @param {IndexManagementApiAdminIndexManagementTeamSupportCustomerIdOrDatabaseNamePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminIndexManagementTeamSupportCustomerIdOrDatabaseNamePost(requestParameters: IndexManagementApiAdminIndexManagementTeamSupportCustomerIdOrDatabaseNamePostRequest, options?: AxiosRequestConfig): AxiosPromise<IndexManagementResponse> {
            return localVarFp.adminIndexManagementTeamSupportCustomerIdOrDatabaseNamePost(requestParameters.idOrDatabaseName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Re-index all records in a Facility Database
         * @param {IndexManagementApiIndexAllEmployeesInADatabaseFacilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllEmployeesInADatabaseFacility(requestParameters: IndexManagementApiIndexAllEmployeesInADatabaseFacilityRequest, options?: AxiosRequestConfig): AxiosPromise<IndexManagementResponse> {
            return localVarFp.indexAllEmployeesInADatabaseFacility(requestParameters.databaseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminIndexManagementFacilityEmployeesFacilityIdPost operation in IndexManagementApi.
 * @export
 * @interface IndexManagementApiAdminIndexManagementFacilityEmployeesFacilityIdPostRequest
 */
export interface IndexManagementApiAdminIndexManagementFacilityEmployeesFacilityIdPostRequest {
    /**
     * The unique identifier of the facility.
     * @type {string}
     * @memberof IndexManagementApiAdminIndexManagementFacilityEmployeesFacilityIdPost
     */
    readonly facilityId: string

    /**
     * A list of primary key employee IDs to be indexed.
     * @type {Array<number>}
     * @memberof IndexManagementApiAdminIndexManagementFacilityEmployeesFacilityIdPost
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for adminIndexManagementSaasEmployeesPost operation in IndexManagementApi.
 * @export
 * @interface IndexManagementApiAdminIndexManagementSaasEmployeesPostRequest
 */
export interface IndexManagementApiAdminIndexManagementSaasEmployeesPostRequest {
    /**
     * An array of SaaS Employee IDs to be indexed
     * @type {Array<string>}
     * @memberof IndexManagementApiAdminIndexManagementSaasEmployeesPost
     */
    readonly requestBody?: Array<string>
}

/**
 * Request parameters for adminIndexManagementTeamSupportCustomerIdOrDatabaseNamePost operation in IndexManagementApi.
 * @export
 * @interface IndexManagementApiAdminIndexManagementTeamSupportCustomerIdOrDatabaseNamePostRequest
 */
export interface IndexManagementApiAdminIndexManagementTeamSupportCustomerIdOrDatabaseNamePostRequest {
    /**
     * The ID or database name of the TeamSupport customer
     * @type {string}
     * @memberof IndexManagementApiAdminIndexManagementTeamSupportCustomerIdOrDatabaseNamePost
     */
    readonly idOrDatabaseName: string
}

/**
 * Request parameters for indexAllEmployeesInADatabaseFacility operation in IndexManagementApi.
 * @export
 * @interface IndexManagementApiIndexAllEmployeesInADatabaseFacilityRequest
 */
export interface IndexManagementApiIndexAllEmployeesInADatabaseFacilityRequest {
    /**
     * 
     * @type {string}
     * @memberof IndexManagementApiIndexAllEmployeesInADatabaseFacility
     */
    readonly databaseId: string
}

/**
 * IndexManagementApi - object-oriented interface
 * @export
 * @class IndexManagementApi
 * @extends {BaseAPI}
 */
export class IndexManagementApi extends BaseAPI {
    /**
     * 
     * @summary Indexes employees for a specific facility based on employee IDs.
     * @param {IndexManagementApiAdminIndexManagementFacilityEmployeesFacilityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndexManagementApi
     */
    public adminIndexManagementFacilityEmployeesFacilityIdPost(requestParameters: IndexManagementApiAdminIndexManagementFacilityEmployeesFacilityIdPostRequest, options?: AxiosRequestConfig) {
        return IndexManagementApiFp(this.configuration).adminIndexManagementFacilityEmployeesFacilityIdPost(requestParameters.facilityId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Re-index all employees based on their SaaS Employee IDs
     * @param {IndexManagementApiAdminIndexManagementSaasEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndexManagementApi
     */
    public adminIndexManagementSaasEmployeesPost(requestParameters: IndexManagementApiAdminIndexManagementSaasEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return IndexManagementApiFp(this.configuration).adminIndexManagementSaasEmployeesPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Re-index all employees belonging to a specific TeamSupport customer
     * @param {IndexManagementApiAdminIndexManagementTeamSupportCustomerIdOrDatabaseNamePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndexManagementApi
     */
    public adminIndexManagementTeamSupportCustomerIdOrDatabaseNamePost(requestParameters: IndexManagementApiAdminIndexManagementTeamSupportCustomerIdOrDatabaseNamePostRequest, options?: AxiosRequestConfig) {
        return IndexManagementApiFp(this.configuration).adminIndexManagementTeamSupportCustomerIdOrDatabaseNamePost(requestParameters.idOrDatabaseName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Re-index all records in a Facility Database
     * @param {IndexManagementApiIndexAllEmployeesInADatabaseFacilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndexManagementApi
     */
    public indexAllEmployeesInADatabaseFacility(requestParameters: IndexManagementApiIndexAllEmployeesInADatabaseFacilityRequest, options?: AxiosRequestConfig) {
        return IndexManagementApiFp(this.configuration).indexAllEmployeesInADatabaseFacility(requestParameters.databaseId, options).then((request) => request(this.axios, this.basePath));
    }
}
